import { FC, ReactNode, useRef } from 'react';
import Modal from '../Modal';
import styles from './ModalContainer.module.scss';
import { popup } from '#store/popup';

type Props = {
  show: boolean;
  children?: ReactNode;
};
const ModalContainer: FC<Props> = ({ children, show }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClosePopup = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      popup.set('')
    }
  }

  return show ? (
    <Modal>
      <div ref={wrapperRef} onClick={handleClosePopup} className={styles.wrapper}>
        {children}
      </div>
    </Modal>
  ) : null;
};

export default ModalContainer;
